// Definizioni condivise per le fasi del ciclo (etichette + classi CSS).

export const PHASE_LABEL = {
  menstruation: 'Mestruazioni',
  follicolare: 'Fase follicolare',
  fertile: 'Finestra fertile',
  ovulazione: 'Ovulazione',
  luteale: 'Fase luteale',
  premestruale: 'Premestruale',
  unknown: 'Da impostare',
};

export const PHASE_LABEL_SHORT = {
  menstruation: 'Mestruazioni',
  follicolare: 'Follicolare',
  fertile: 'Fertile',
  ovulazione: 'Ovulazione',
  luteale: 'Luteale',
  premestruale: 'Premestruale',
  unknown: '—',
};

// classNames CSS abbinati a phase-<key>
export function phaseClass(phase) {
  return `phase phase-${phase || 'unknown'}`;
}

// Calcolo della fase lato client (mirror semplificato del backend) per uso
// in calendario dove le chiamate API sarebbero costose.
const LUTEAL_LENGTH = 14;
const FERTILE_BEFORE = 5;
const FERTILE_AFTER = 1;
const PMS_DAYS = 5;
const DEFAULT_CYCLE = 28;
const DEFAULT_PERIOD = 5;

function diffDays(a, b) {
  const ms = new Date(a).setHours(0, 0, 0, 0) - new Date(b).setHours(0, 0, 0, 0);
  return Math.round(ms / 86400000);
}

export function computeAverages(periods) {
  if (!periods || periods.length === 0) {
    return { cycleLength: DEFAULT_CYCLE, periodLength: DEFAULT_PERIOD };
  }
  const sorted = [...periods].sort((a, b) => (a.startDate < b.startDate ? -1 : 1));
  const gaps = [];
  for (let i = 1; i < sorted.length; i++) {
    const g = diffDays(sorted[i].startDate, sorted[i - 1].startDate);
    if (g >= 18 && g <= 45) gaps.push(g);
  }
  const lens = sorted
    .filter((p) => p.endDate)
    .map((p) => diffDays(p.endDate, p.startDate) + 1)
    .filter((n) => n >= 1 && n <= 14);
  return {
    cycleLength: gaps.length
      ? Math.round(gaps.reduce((a, b) => a + b, 0) / gaps.length)
      : DEFAULT_CYCLE,
    periodLength: lens.length
      ? Math.round(lens.reduce((a, b) => a + b, 0) / lens.length)
      : DEFAULT_PERIOD,
  };
}

export function phaseForDateClient(periods, dateStr) {
  if (!periods || periods.length === 0) return { phase: 'unknown' };
  const { cycleLength, periodLength } = computeAverages(periods);
  const target = new Date(`${dateStr}T00:00:00`);
  const sorted = [...periods].sort((a, b) => (a.startDate < b.startDate ? 1 : -1));

  for (const p of sorted) {
    const start = new Date(`${p.startDate}T00:00:00`);
    const end = p.endDate
      ? new Date(`${p.endDate}T00:00:00`)
      : new Date(start.getTime() + (periodLength - 1) * 86400000);
    if (target >= start && target <= end) {
      return { phase: 'menstruation', dayOfCycle: diffDays(target, start) + 1 };
    }
  }
  const last = sorted.find((p) => new Date(`${p.startDate}T00:00:00`) <= target);
  if (!last) return { phase: 'unknown' };

  const lastStart = new Date(`${last.startDate}T00:00:00`);
  const day = diffDays(target, lastStart) + 1;
  const ovulationDay = cycleLength - LUTEAL_LENGTH;
  const fertileFrom = ovulationDay - FERTILE_BEFORE;
  const fertileTo = ovulationDay + FERTILE_AFTER;
  const pmsFrom = cycleLength - PMS_DAYS + 1;

  let phase;
  if (day === ovulationDay) phase = 'ovulazione';
  else if (day >= fertileFrom && day <= fertileTo) phase = 'fertile';
  else if (day < ovulationDay) phase = 'follicolare';
  else if (day >= pmsFrom) phase = 'premestruale';
  else phase = 'luteale';

  return { phase, dayOfCycle: day };
}
